<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="p-4">
  <div class="grid mb-3 align-items-end">
    <div class="col-12 md:col-4">
      <span class="p-float-label" style="min-width:260px;">
        <p-dropdown
          [options]="properties"
          [optionLabel]="'propertyCode'"
          [optionValue]="'shortTermRentalId'"
          [(ngModel)]="selectedShortTermRentalId"
          [filter]="true"
          filterBy="propertyCode"
          [showClear]="true"
          placeholder="Filter by Property">
        </p-dropdown>
        <label>Filter by Property</label>
      </span>
    </div>

    <div class="col-12 md:col-3">
      <span class="p-float-label">
        <p-dropdown
          [options]="daysBackOptions"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="daysBack"
          (onChange)="onDaysBackChange()"
          [style]="{minWidth: '160px'}"
          placeholder="Lookback">
        </p-dropdown>
        <label>Lookback Window</label>
      </span>
    </div>

    <div class="col-12 md:col-2">
      <button pButton
              icon="pi pi-refresh"
              label="Refresh"
              class="p-button-outlined p-button-sm"
              (click)="loadData()"
              [disabled]="formLoading">
      </button>
    </div>
  </div>

  <p-table #dt [value]="filteredRows" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,50,100]">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 200px;">
          Create Date
          <br>
            <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'createDate', 'contains')" placeholder="Filter" style="width:100%;">
          </th>
          <th style="width: 160px;">
            ShortTermRental ID
            <br>
              <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'shortTermRentalId', 'equals')" placeholder="Filter" style="width:100%;">
            </th>
            <th style="width: 140px;">
              Status
              <br>
                <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'queueStatus', 'contains')" placeholder="Filter" style="width:100%;">
              </th>
              <th>
                Result
                <br>
                  <input pInputText type="text" (input)="dt.filter($any($event.target).value, 'testResultDesc', 'contains')" placeholder="Filter" style="width:100%;">
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td>{{row.createDate | date:'short'}}</td>
                <td>{{row.shortTermRentalId}}</td>
                <td>{{row.queueStatus}}</td>
                <td>{{row.testResultDesc}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
